import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightPipe } from './pipe/highlight.pipe';
import { HighlightSearchPipe } from './pipe/highlight-search.pipe';
import { StripFootnotePipe } from './pipe/strip-footnote.pipe';

@NgModule({
    declarations: [HighlightPipe, HighlightSearchPipe, StripFootnotePipe],
    imports: [CommonModule],
    providers: [HighlightPipe, HighlightSearchPipe, StripFootnotePipe],
    exports: [HighlightPipe, HighlightSearchPipe, StripFootnotePipe],
})
export class CommonPipesModule { }
